__turbopack_context__.v({
  "footerContent": "FooterList-module-scss-module__T7qPSG__footerContent",
  "footerHeading": "FooterList-module-scss-module__T7qPSG__footerHeading",
  "footerNav": "FooterList-module-scss-module__T7qPSG__footerNav",
  "listingsFooter": "FooterList-module-scss-module__T7qPSG__listingsFooter",
});
